import React from 'react';
import { FiFile } from 'react-icons/fi';

const FormFabrikasi = ({
  formData,
  handleFabrikasiChange,
  setFormData
}) => {
  if (formData.category !== 'Fabrikasi') return null;

  const materialTypes = ['Baja Karbon', 'Stainless Steel', 'Aluminium', 'Kuningan', 'Tembaga', 'Plastik', 'Komposit'];
  const weldingTypes = ['SMAW', 'GMAW', 'GTAW', 'FCAW', 'SAW', 'Laser', 'Ultrasonic'];
  const surfaceTreatments = ['Cat Epoxy', 'Powder Coating', 'Galvanis', 'Anodizing', 'Chrome', 'Polishing', 'None'];

  return (
    <div className="bg-[var(--bg-primary)] p-6 rounded-xl shadow-[var(--shadow-sm)] border border-[var(--border-color)]">
      <h3 className="text-lg font-semibold text-[var(--text-primary)] mb-4">
        Detail Fabrikasi
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-[var(--text-secondary)] mb-1">
            Jenis Material
          </label>
          <select
            name="materialType"
            value={formData.fabrikasiDetails.materialType}
            onChange={handleFabrikasiChange}
            className="w-full px-3 py-2 border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)] focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Pilih Material</option>
            {materialTypes.map(type => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-[var(--text-secondary)] mb-1">
            Ketebalan Material (mm)
          </label>
          <input
            type="number"
            name="materialThickness"
            value={formData.fabrikasiDetails.materialThickness || ''}
            onChange={handleFabrikasiChange}
            placeholder="Contoh: 5"
            className="w-full px-3 py-2 border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)] focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-[var(--text-secondary)] mb-1">
            Dimensi (P x L x T)
          </label>
          <input
            type="text"
            name="dimensions"
            value={formData.fabrikasiDetails.dimensions}
            onChange={handleFabrikasiChange}
            placeholder="Contoh: 2000x1500x800"
            className="w-full px-3 py-2 border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)] focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-[var(--text-secondary)] mb-1">
            Berat (kg)
          </label>
          <input
            type="number"
            name="weight"
            value={formData.fabrikasiDetails.weight}
            onChange={handleFabrikasiChange}
            placeholder="Contoh: 150"
            className="w-full px-3 py-2 border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)] focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-[var(--text-secondary)] mb-1">
            Jenis Pengelasan
          </label>
          <select
            name="weldingType"
            value={formData.fabrikasiDetails.weldingType}
            onChange={handleFabrikasiChange}
            className="w-full px-3 py-2 border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)] focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Pilih Metode</option>
            {weldingTypes.map(type => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-[var(--text-secondary)] mb-1">
            Perlakuan Permukaan
          </label>
          <select
            name="surfaceTreatment"
            value={formData.fabrikasiDetails.surfaceTreatment}
            onChange={handleFabrikasiChange}
            className="w-full px-3 py-2 border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)] focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Pilih Perlakuan</option>
            {surfaceTreatments.map(type => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-[var(--text-secondary)] mb-1">
            Jumlah
          </label>
          <input
            type="number"
            name="quantity"
            value={formData.fabrikasiDetails.quantity}
            onChange={handleFabrikasiChange}
            placeholder="Contoh: 2"
            className="w-full px-3 py-2 border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)] focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-[var(--text-secondary)] mb-1">
            Satuan
          </label>
          <input
            type="text"
            name="unit"
            value={formData.fabrikasiDetails.unit}
            onChange={handleFabrikasiChange}
            placeholder="unit, set, pcs"
            className="w-full px-3 py-2 border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)] focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Blueprint */}
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-[var(--text-secondary)] mb-1">
            Gambar Kerja / Blueprint
          </label>
          <input
            type="file"
            accept="image/*,.pdf"
            onChange={(e) => {
              const file = e.target.files[0];
              if (file) {
                const reader = new FileReader();
                reader.onloadend = () => {
                  setFormData(prev => ({
                    ...prev,
                    fabrikasiDetails: {
                      ...prev.fabrikasiDetails,
                      blueprint: reader.result
                    }
                  }));
                };
                reader.readAsDataURL(file);
              }
            }}
            className="w-full px-3 py-2 border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)]"
          />
          {formData.fabrikasiDetails.blueprint && (
            <div className="mt-2">
              {formData.fabrikasiDetails.blueprint.startsWith('data:image') ? (
                <img 
                  src={formData.fabrikasiDetails.blueprint} 
                  alt="Blueprint" 
                  className="max-h-48 rounded-lg border border-[var(--border-color)] object-contain"
                />
              ) : (
                <div className="flex items-center gap-2 text-sm text-[var(--text-secondary)]">
                  <FiFile size={16} className="text-red-500" />
                  <span>PDF Blueprint</span>
                  <button
                    type="button"
                    onClick={() => {
                      setFormData(prev => ({
                        ...prev,
                        fabrikasiDetails: {
                          ...prev.fabrikasiDetails,
                          blueprint: null
                        }
                      }));
                    }}
                    className="text-red-500 hover:text-red-700"
                  >
                    Hapus
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FormFabrikasi;